// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3vTOW","location":"Header_location__2646s"};